<template>
  <section>
    <b-sidebar
      id="manage-district-court"
      :visible="isUpdateDistrictCourtSidebarActive"
      bg-variant="white"
      sidebar-class="sidebar-lg"
      shadow
      backdrop
      no-header
      right
      @hidden="resetForm"
      @change="(val) => $emit('update:isUpdateDistrictCourtSidebarActive', val)"
    >
      <template #default="{ hide }">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h5 class="mb-0">Manage District Courts</h5>

          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hide"
          />
        </div>

        <!-- BODY -->
        <validation-observer ref="refFormObserver" v-slot="{ handleSubmit }">
          <b-form
            class="px-2 pt-1"
            @submit.prevent="handleSubmit(onSubmit)"
            @reset.prevent="resetForm"
          >

            <!-- Select Single District Court -->
            <validation-provider name="District Court" rules="required" v-slot="validationContext">
              <b-form-group
                label="Select District Court *"
                label-for="district-court"
              >
                <v-select
                  id="district-court"
                  v-model="formData.court_id"
                  :options="districtOptions"
                  label="label"
                  :reduce="(val) => val.value"
                  :clearable="true"
                  placeholder="Select District Court"
                  class="mb-1"
                />
                <small class="text-danger">{{ validationContext.errors[0] }}</small>
              </b-form-group>
            </validation-provider>

            <!-- Filter Lawyer Names -->
            <validation-provider name="Filter Names">
              <b-form-group label="Filter Names" label-for="filter_by_names">
                <b-form-tags
                  v-model="formData.filter_by_names"
                  placeholder="Add Lawyer Names"
                  input-id="filter_by_names"
                />
                <b-form-invalid-feedback :state="false" class="text-info">
                  Type and press enter to push new name.
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <!-- Submit -->
            <div class="d-flex mt-2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                block
                type="submit"
                :disabled="!formData.court_id"
              >
                Add District Court
              </b-button>
            </div>
          </b-form>
        </validation-observer>

        <hr class="my-2" />

        <!-- List -->
        <h6 class="pl-1">District Courts List</h6>
        <b-list-group class="m-1">
          <div v-for="item in districtCourtsList" :key="item._id">
            <tribunal-court-item
              :tribunalData="item"
              :data="userData"
              courtType="district"
              @refetch-data="fetchDistrictCourts"
            />
          </div>
        </b-list-group>
      </template>
    </b-sidebar>
  </section>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormTags, BButton,
  BListGroup, BListGroupItem, BFormInvalidFeedback
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { ref } from '@vue/composition-api'
import store from '@/store'
import Ripple from 'vue-ripple-directive'
import TribunalCourtItem from './TribunalCourtItem.vue'

export default {
  name: 'UserDistrictCourtUpdate',
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormTags,
    BButton,
    vSelect,
    BListGroup,
    BListGroupItem,
    BFormInvalidFeedback,
    ValidationObserver,
    ValidationProvider,
    TribunalCourtItem
  },
  directives: { Ripple },

  props: {
    isUpdateDistrictCourtSidebarActive: Boolean,
    data: Object,
    districtOptions: Array
  },

  setup(props, { emit }) {

    const userData = props.data

    const formData = ref({
      user_id: userData._id,
      court_id: null,
      filter_by_names: [],
      court_type: "district"
    })

    const districtCourtsList = ref([])

    // Fetch API
    const fetchDistrictCourts = () => {
      store.dispatch("userStore/fetchTribunalsById", {
        id: userData._id,
        court_type: "district"
      }).then(response => {
        districtCourtsList.value = response || []
      })
    }

    // Submit API
    const onSubmit = () => {
      store.dispatch("userStore/saveTribunal", {
        payload: { ...formData.value }
      }).then((response) => {
        if (response) fetchDistrictCourts()
      })
    }

    const resetForm = () => {
      formData.value.court_id = null
      formData.value.filter_by_names = []
    }

    return {
      formData,
      districtCourtsList,
      userData,
      onSubmit,
      resetForm,
      fetchDistrictCourts
    }
  }
}
</script>

<style scoped lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#manage-district-court {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
